import React, { useCallback } from 'react';
import { useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import moment from 'moment';
import ReactQuill from 'react-quill';

import { useGetNotificationQuery } from 'api/main';
import { texts } from 'utils/languages/fr';
import 'react-quill/dist/quill.bubble.css';

import { Loader } from 'components';
import { Box, Grid, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { ArrowLeft } from 'mdi-material-ui';

const useStyles = makeStyles(theme => ({
    column: {
        '&:not(:last-child)': {
            marginRight: theme.spacing(0, 4),
        },
    },
    return: {
        lineHeight: 1,
        fontSize: 13,
        color: theme.palette.grey[700],
        flex: '0 1',
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        textTransform: 'uppercase',
    },
    dataBox: {
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 5,
        padding: 20,
        background: theme.palette.grey[200],
        marginBottom: theme.spacing(5),
        marginTop: theme.spacing(3),
    },
}));

const InfoLabel = ({ children }) => <Typography sx={{ fontWeight: '600' }}>{children}</Typography>;

const MessageDetails = () => {
    const classes = useStyles();
    const { id } = useParams();
    const dispatch = useDispatch();

    const { data: notification = { data: {} }, isLoading } = useGetNotificationQuery(id);

    const handleReturn = useCallback(() => dispatch(push('/sent-messages')), [dispatch]);

    return (
        <Loader loading={isLoading}>
            <Typography variant="h5" align="left" gutterBottom>
                {texts.SENT_MESSAGES}
            </Typography>
            <Box className={classes.dataBox}>
                <Grid container spacing={4}>
                    <Grid item className={classes.column}>
                        <InfoLabel>{`${texts.USER_TYPE} :`}</InfoLabel>
                        <InfoLabel>{`${texts.NOM} :`}</InfoLabel>
                        <InfoLabel>{`${texts.SENDING_DATE} :`}</InfoLabel>
                        <InfoLabel>{`${texts.MESSAGE_SUBJECT} :`}</InfoLabel>
                        <InfoLabel>{`${texts.MESSAGE_CONTENT} :`}</InfoLabel>
                    </Grid>
                    <Grid item className={classes.column}>
                        <Typography>{notification?.type || '-'}</Typography>
                        <Typography>{notification?.name || '-'}</Typography>
                        <Typography>
                            {notification?.[0]?.createdAt
                                ? moment(notification?.[0]?.createdAt).format('L')
                                : '-'}
                        </Typography>
                        <Typography>{notification?.[0]?.subject}</Typography>
                        <Typography></Typography>
                    </Grid>
                </Grid>
                {!!notification?.[0]?.content && (
                    <ReactQuill value={notification[0].content} readOnly theme="bubble" />
                )}
            </Box>
            <Box display="flex" alignItems="center" justifyContent="space-between">
                <Typography onClick={handleReturn} className={classes.return}>
                    <ArrowLeft className={classes.navIcon} /> {texts.RETOUR}
                </Typography>
            </Box>
        </Loader>
    );
};

export default MessageDetails;
